import { UploadedFileVideo } from '@/component/FileUpload/types';
import { ViewPracticalAssessmentVideoPreviewEmbed } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/ViewPracticalAssessmentVideoPreviewEmbed';
import { ViewPracticalAssessmentVideoPreviewVimeo } from '@/administration/pages/Course/pages/assessments/practicalAssessmentVideo/variants/View/ViewPracticalAssessmentVideoPreviewVimeo';

type ViewPracticalAssessmentVideoPreviewProps = {
  videoLink?: string;
  uploadedFileVideo?: UploadedFileVideo;
};

export const ViewPracticalAssessmentVideoPreview = ({
  videoLink,
  uploadedFileVideo,
}: ViewPracticalAssessmentVideoPreviewProps): JSX.Element => {
  return (
    <>
      {videoLink && <ViewPracticalAssessmentVideoPreviewEmbed videoLink={videoLink} />}
      {uploadedFileVideo?.vimeoId && <ViewPracticalAssessmentVideoPreviewVimeo uploadedFileVideo={uploadedFileVideo} />}
    </>
  );
};
